<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'quiz'
};
</script>

<style lang="less" scoped></style>
